import {
    animate,
    createTimeline,
    createTimer,
    utils,
    // ...other methods
  } from 'animejs';
const anime = animate;

function install(Vue) {
    Vue.directive('anime', {
        bind: function bind(targets, binding) {
            //console.log('bind', targets, binding);
            anime(targets, binding.value);
        },
        update: function update(targets, binding) {
            anime(targets, binding.value);
        }
    });
    Vue.prototype.$anime = anime;
}
export default {
    install: install,
    anime: anime,
    animate:animate,
    utils:utils,
}
